import React from 'react';
import styles from '../assets/styles/Doc.module.scss';
import PublicHeader from '../components/PublicHeader';

import { useScrollToTop } from '../hooks/useScrollToTop';

const HomePage: React.FC = () => {
  useScrollToTop();
  return (
    <>
      <PublicHeader />
      <div className={styles.container}>
        <div className={styles.docContent}>
          <h1>利用規約</h1>
          <p className={styles.mainTxt}>
            本利用規約（以下「本規約」）は、株式会社Inovis（以下「当社」）が提供する「AIBEX」サービス（以下「本サービス」）の利用条件を定めるものです。本サービスを利用されるすべての法人および個人（以下「利用者」）は、本規約に同意したうえで本サービスを利用するものとします。
          </p>
          <h2>第1条（適用）</h2>
          <ul className={styles.list1}>
            <li>本規約は、利用者と当社との間で、本サービスの利用に関して適用される契約（以下「本利用契約」）の内容を構成します。</li>
            <li>利用者が本サービスをお申し込みまたは利用開始された時点で、本規約の内容に同意したものとみなされます。</li>
          </ul>

          <h2>第2条（定義）</h2>
          <p>本規約において、次の各号の用語はそれぞれ以下の意味を有します。</p>
          <ul className={styles.list1}>
            <li>「利用開始日」とは、当社が利用者に対して本サービスの利用を許可した日を指します。</li>
            <li>「知的財産権」とは、著作権、商標権、意匠権、特許権、営業秘密その他の知的財産に関する一切の権利をいいます。</li>
            <li>「ユーザーコンテンツ」とは、利用者が本サービスを通じて入力、投稿、アップロード、送信する一切の情報、データ、テキスト、画像、動画、音声その他のコンテンツをいいます。</li>
          </ul>
          <br />
          <p>その他、本サービスに関連して当社が別途定める用語については、当社所定の定義によります。</p>

          <h2>第3条（サービス内容・提供）</h2>
          <p>
            当社は、利用者に対して本サービスの機能および仕様を提示し、契約プランに応じて広告運用の最適化・自動出稿支援機能・分析レポート支援機能等を提供します。<br />
            利用者は、本サービスの利用に必要な機器（PC、スマートフォン等）および通信環境を自己の責任と負担において準備するものとします。
          </p>

          <h2>第4条（契約の成立）</h2>
          <p>
            本サービスの利用申込みを行った利用者が、当社の所定の審査を経て承諾を受けた時点で、本利用契約が成立します。<br />
            当社は、利用申込みを承諾しない場合があります。
          </p>

          <h2>第5条（利用料・支払）</h2>
          <p>
            利用者は、契約プランに応じて当社所定の利用料金（初期費用・月額費用・広告運用費連動フィー等）を支払うものとします。<br />
            支払方法、期日等は当社が定め別途案内するものとします。<br />
            利用者が支払を怠った場合、当社は本サービスの停止または契約解除を行うことができ、未払分の請求を行うことができます。
          </p>

          <h2>第6条（知的財産権）</h2>
          <p>
            本サービスおよびその仕様、提供コンテンツ、プログラム、マニュアル、ドキュメント等に関する知的財産権は、すべて当社または正当なライセンサーに帰属します。<br />
            利用者は、当社またはライセンサーの承諾なしに複製、改変、リバースエンジニアリング、貸与、譲渡、再配布等を行ってはなりません。<br />
            利用者が本サービスを通じて投稿またはアップロードしたユーザーコンテンツの権利は利用者に帰属しますが、当社は本サービス運営のためそれらを利用（複製、改変、配信）する権利を許諾されているものとします。
          </p>

          <h2>第7条（禁止事項）</h2>
          <p>利用者は本サービスの利用にあたって、以下の行為をしてはならないものとします。</p>
          <ul className={styles.list1}>
            <li>法令または公序良俗に反する行為。</li>
            <li>他者の知的財産権、プライバシー、名誉その他の権利を侵害する行為。</li>
            <li>虚偽の情報を入力・登録する行為。</li>
            <li>本サービスの運営を妨害する行為、またはその恐れがある行為。</li>
            <li>本サービスを第三者に無断で使用させる行為、または営利目的で再提供する行為（ただし別途当社の承諾を得たものを除きます）。</li>
            <li>本サービスの仕様を逆解析、リバースエンジニアリング、または複製・改変を行う行為。</li>
            <li>当社または第三者に対し、当社が提携・許諾しているかのように偽って表示する行為。</li>
            <li>その他、当社が不適切と判断する行為。</li>
          </ul>

          <h2>第8条（機密保持）</h2>
          <p>
            利用者および当社は、本利用契約および本サービスを通じて知り得た相手方の機密情報を第三者に開示・漏洩してはなりません。<br />
            前項の義務は、本利用契約終了後も継続します。
          </p>

          <h2>第9条（保証および免責）</h2>
          <p>
            当社は、本サービスが利用者の期待する成果（広告費対効果、入札価格、クリエイティブ効果等）を必ずしも保証するものではありません。<br />
            当社は、本サービスの提供中断、遅延、中止によって利用者に生じた損害について、一切の責任を負わないものとします。ただし、当社に故意または重大な過失がある場合を除きます。<br />
            利用者は、本サービスの利用により第三者からクレーム、損害賠償請求等を受けた場合、自らの責任と費用負担においてこれを処理し、当社に損害を与えた場合はこれを賠償するものとします。
          </p>

          <h2>第10条（契約期間・解約）</h2>
          <p>
            本利用契約の契約期間は、当社と利用者が別途合意した期間とします。期間満了日の30日前までに書面または電子的方法による解約の申出がない場合、自動更新されるものとします。<br />
            利用者は、当社が定める方法により解約申出を行うことができます。<br />
            当社は、利用者が本規約に違反した場合、利用契約を解除または本サービスの利用停止を行うことができます。
          </p>

          <h2>第11条（変更・停止）</h2>
          <p>
            当社は、本サービスの内容、仕様、料金、運用条件等をいつでも変更・追加・廃止できるものとします。変更後の内容は、当社ウェブサイト上に掲示するか、利用者に通知することで効力を生じます。<br />
            当社は、本サービスの提供を一時的に停止することがあります。停止の理由には、システム点検、通信障害、天災その他やむを得ない事情が含まれます。なお当社は、一切の損害賠償義務を負いません。
          </p>

          <h2>第12条（損害賠償）</h2>
          <p>利用者が本規約に違反し、当社に損害を与えた場合、利用者は当社に対し当該損害（合理的な弁護士費用を含む）を賠償するものとします。</p>

          <h2>第13条（通知方法）</h2>
          <p>当社が利用者への通知を行う場合、当社ウェブサイト上の掲示、電子メール、その他当社が定める方法によるものとします。利用者は、当社が登録された電子メールアドレス宛に送信した通知を受領したものとみなされます。</p>

          <h2>第14条（準拠法・管轄）</h2>
          <p>
            本規約の準拠法は日本法とします。<br />
            本利用契約または本規約に関して紛争が生じた場合、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
          </p>

          <h2>第15条（その他）</h2>
          <p>
            本規約に定めのない事項および本規約の解釈に関しては、当社と利用者が誠実に協議のうえ定めるものとします。<br />
            本規約のいずれかの条項が、法令により無効または執行不能と判断された場合でも、その他の条項の効力には影響を及ぼさないものとします。
          </p>
          <br />
          <p>
            制定日：2025年10月28日<br />
            改定日：2025年10月28日（初版）
          </p>
        </div>
      </div>
    </>
  );
};

export default HomePage;
